module.exports = __webpack_public_path__ + "static_pc/img/int01.7f519c35.png";